var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_12_5",
    "data-name": "Component 12 \\u2013 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.375,
    viewBox: "0 0 18 12.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-fill",
    transform: "translate(0 -5.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M18,15.188a2.812,2.812,0,1,1-2.812-2.812A2.812,2.812,0,0,1,18,15.188Z",
    transform: "translate(-6.188 -3.375)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M0,11.813S3.375,5.625,9,5.625s9,6.188,9,6.188S14.625,18,9,18,0,11.813,0,11.813ZM9,15.75a3.938,3.938,0,1,0-3.937-3.937A3.937,3.937,0,0,0,9,15.75Z",
    fill: "#74613c",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.204e3aca4562b203d15c431664d19127.svg";
export { ForwardRef as ReactComponent };